export interface StandaloneAccessoryModel {
  id?: string;
  siteId?: string;
  assetId?: string;
  deviceKey?: string;
  deviceId?: string;
  productNumber?: string;
  serialNumber?: string;
  productDescription?: string;

  sentToK2?: boolean;
  installed?: boolean;
  lockedToSite?: boolean;
  ordered?: boolean;

  assetDeviceKey?: string;
  assetProductNumber?: string;
  assetProductDescription?: string;
  assetSerialNumber?: string;
}

export function standaloneAccessoryModelFactory(json?: any): StandaloneAccessoryModel {
  json = json || {};

  return {
    id: json.id || "",
    siteId: json.siteId || "",
    assetId: json.assetId || "",
    deviceKey: json.deviceKey || "",
    deviceId: json.deviceId || "",
    productNumber: json.productNumber || "",
    serialNumber: json.serialNumber || "",
    productDescription: json.productDescription || "",

    sentToK2: !!json.sentToK2,
    installed: !!json.installed,
    lockedToSite: !!json.lockedToSite,
    ordered: !!json.ordered,

    assetDeviceKey: json.assetDeviceKey || "",
    assetProductNumber: json.assetProductNumber || "",
    assetProductDescription: json.assetProductDescription || "",
    assetSerialNumber: json.assetSerialNumber || "",
  } as StandaloneAccessoryModel;
}

export function standaloneAccessoryModelListFactory(json?: any): StandaloneAccessoryModel[] {
  return Array.from(json || []).map(it => standaloneAccessoryModelFactory(it));
}
